<template>
  <div class="wrapper deposit-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <h1>{{ $t("CHARGE") }}</h1>
          <div class="tab-area">
            <div
              class="tab link-over"
              v-on:click="isSelect('1')"
              v-bind:class="{ active: isActive === '1' }"
            >
              BTC
            </div>
            <div
              class="tab link-over"
              v-on:click="isSelect('2')"
              v-bind:class="{ active: isActive === '2' }"
            >
              ETH（ERC20）
            </div>
            <div
              class="tab link-over"
              v-on:click="isSelect('3')"
              v-bind:class="{ active: isActive === '3' }"
            >
              USDT（BEP20）
            </div>
            <div
              class="tab link-over"
              v-on:click="isSelect('4')"
              v-bind:class="{ active: isActive === '4' }"
            >
              USDT（TRC20）
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '1'"
            v-bind:class="{ active: isActive === '1' }"
          >
            <div class="balance">
              <div class="error-msg">
                {{ $t("※Minimum deposit 100 USD") }}
              </div>
              <div class="input-area">
                <input
                  type="text"
                  :placeholder="$t('USD amount you want to charge')"
                />
                <button type="button" class="link-over">
                  {{ $t("Calculate") }}
                </button>
              </div>
              <div class="exchange">
                <div class="currency">
                  {{ $t("Amount required for charging") }}
                </div>
                <div class="price"><span>0.0001</span>BTC</div>
              </div>
              <div class="wallet-img">
                <img src="../assets/img/wallet-img.svg" alt="" />
              </div>
              <div class="copy-address">
                <div class="input-area">
                  <input
                    type="text"
                    id="address1"
                    v-model="address1"
                    value="WALLET ADDRESSを表示する"
                    readonly
                  />
                  <span
                    class="copy-btn"
                    v-clipboard:copy="address1"
                    v-clipboard:success="addressCopy1"
                    v-clipboard:error="addressError1"
                    >COPY</span
                  >
                </div>
              </div>
              <div class="notice-txt">
                <p>
                  {{
                    $t(
                      "※Deposits made in currencies other than USDT will be converted to USDT at the rate at the time of receipt and will be reflected in the system."
                    )
                  }}
                </p>
                <p>{{ $t("※Minimum deposit 100 USD") }}</p>
              </div>
            </div>
            <div class="table">
              <h2>{{ $t("Charge history") }}</h2>
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Point") }}</th>
                  <th>{{ $t("Charge amount") }}</th>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>BTC</td>
                  <td>0.01BTC</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>BTC</td>
                  <td>0.01BTC</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>BTC</td>
                  <td>0.01BTC</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>BTC</td>
                  <td>0.01BTC</td>
                </tr>
              </table>
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '2'"
            v-bind:class="{ active: isActive === '2' }"
          >
            <div class="balance">
              <div class="error-msg">
                {{ $t("※Minimum deposit 100 USD") }}
              </div>
              <div class="input-area">
                <input
                  type="text"
                  :placeholder="$t('USD amount you want to charge')"
                />
                <button type="button" class="link-over">
                  {{ $t("Calculate") }}
                </button>
              </div>
              <div class="exchange">
                <div class="currency">
                  {{ $t("Amount required for charging") }}
                </div>
                <div class="price"><span>0.0001</span>ETH</div>
              </div>
              <div class="wallet-img">
                <img src="../assets/img/wallet-img.svg" alt="" />
              </div>
              <div class="copy-address">
                <div class="input-area">
                  <input
                    type="text"
                    id="address"
                    value="WALLET ADDRESSを表示する"
                    v-model="address3"
                    readonly
                  />
                  <span
                    class="copy-btn"
                    v-clipboard:copy="address3"
                    v-clipboard:success="addressCopy3"
                    v-clipboard:error="addressError3"
                    >COPY</span
                  >
                </div>
              </div>
              <div class="notice-txt">
                <p>
                  {{
                    $t(
                      "※Deposits made in currencies other than USDT will be converted to USDT at the rate at the time of receipt and will be reflected in the system."
                    )
                  }}
                </p>
                <p>{{ $t("※Minimum deposit 100 USD") }}</p>
              </div>
            </div>
            <div class="table">
              <h2>{{ $t("Charge history") }}</h2>
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Point") }}</th>
                  <th>{{ $t("Charge amount") }}</th>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>ETH</td>
                  <td>0.01ETH</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>ETH</td>
                  <td>0.01ETH</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>ETH</td>
                  <td>0.01ETH</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>ETH</td>
                  <td>0.01ETH</td>
                </tr>
              </table>
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '3'"
            v-bind:class="{ active: isActive === '3' }"
          >
            <div class="balance">
              <div class="error-msg">
                {{ $t("※Minimum deposit 100 USD") }}
              </div>
              <div class="input-area">
                <input
                  type="text"
                  :placeholder="$t('USD amount you want to charge')"
                />
                <button type="button" class="link-over">
                  {{ $t("Calculate") }}
                </button>
              </div>
              <div class="exchange">
                <div class="currency">
                  {{ $t("Amount required for charging") }}
                </div>
                <div class="price"><span>0.0001</span>USDT</div>
              </div>
              <div class="wallet-img">
                <img src="../assets/img/wallet-img.svg" alt="" />
              </div>
              <div class="copy-address">
                <div class="input-area">
                  <input
                    type="text"
                    id="address"
                    value="WALLET ADDRESSを表示する"
                    v-model="address2"
                    readonly
                  />
                  <span
                    class="copy-btn"
                    v-clipboard:copy="address2"
                    v-clipboard:success="addressCopy2"
                    v-clipboard:error="addressError2"
                    >COPY</span
                  >
                </div>
                <!-- <div class="notice">
                  {{
                    $t(
                      "※Deposits made in currencies other than USDT will be converted to USDT at the rate at the time of receipt and will be reflected in the system."
                    )
                  }}
                </div> -->
              </div>
              <div class="notice-txt">
                <p>
                  {{
                    $t(
                      "※Deposits made in currencies other than USDT will be converted to USDT at the rate at the time of receipt and will be reflected in the system."
                    )
                  }}
                </p>
                <p>{{ $t("※Minimum deposit 100 USD") }}</p>
              </div>
            </div>
            <div class="table">
              <h2>{{ $t("Charge history") }}</h2>
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Point") }}</th>
                  <th>{{ $t("Charge amount") }}</th>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                </tr>
              </table>
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '4'"
            v-bind:class="{ active: isActive === '4' }"
          >
            <div class="balance">
              <div class="error-msg">
                {{ $t("※Minimum deposit 100 USD") }}
              </div>
              <div class="input-area">
                <input
                  type="text"
                  :placeholder="$t('USD amount you want to charge')"
                />
                <button type="button" class="link-over">
                  {{ $t("Calculate") }}
                </button>
              </div>
              <div class="exchange">
                <div class="currency">
                  {{ $t("Amount required for charging") }}
                </div>
                <div class="price"><span>0.0001</span>USDT</div>
              </div>
              <div class="wallet-img">
                <img src="../assets/img/wallet-img.svg" alt="" />
              </div>
              <div class="copy-address">
                <div class="input-area">
                  <input
                    type="text"
                    id="address"
                    value="WALLET ADDRESSを表示する"
                    v-model="address2"
                    readonly
                  />
                  <span
                    class="copy-btn"
                    v-clipboard:copy="address2"
                    v-clipboard:success="addressCopy2"
                    v-clipboard:error="addressError2"
                    >COPY</span
                  >
                </div>
                <!-- <div class="notice">
                  {{
                    $t(
                      "※Deposits made in currencies other than USDT will be converted to USDT at the rate at the time of receipt and will be reflected in the system."
                    )
                  }}
                </div> -->
              </div>
              <div class="notice-txt">
                <p>
                  {{
                    $t(
                      "※Deposits made in currencies other than USDT will be converted to USDT at the rate at the time of receipt and will be reflected in the system."
                    )
                  }}
                </p>
                <p>{{ $t("※Minimum deposit 100 USD") }}</p>
              </div>
            </div>
            <div class="table">
              <h2>{{ $t("Charge history") }}</h2>
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Point") }}</th>
                  <th>{{ $t("Charge amount") }}</th>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <Footer title="Deposit2" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Deposit2",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      title: "Deposit2",
      isActive: "1",
      address1: "WALLET ADDRESSを表示する1",
      address2: "WALLET ADDRESSを表示する2",
      address3: "WALLET ADDRESSを表示する3",
    };
  },
  methods: {
    isSelect: function (num) {
      this.isActive = num;
    },
    addressCopy1: function (e) {
      alert("You just copied: " + e.text);
    },
    addressError1: function () {
      alert("Failed to copy texts");
    },
    addressCopy2: function (e) {
      alert("You just copied: " + e.text);
    },
    addressError2: function () {
      alert("Failed to copy texts");
    },
    addressCopy3: function (e) {
      alert("You just copied: " + e.text);
    },
    addressError3: function () {
      alert("Failed to copy texts");
    },
  },
  computed: {},
  mounted: function () {},
};
</script>
